import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Cruz } from '@cruz-com/lookup'

export async function importByUri(uri: string): Promise<Api.Result<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/my/avatar/uri`, {
      method: 'POST',
      headers: await fetchHeaders(),
      body: JSON.stringify({ uri }),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function uploadAvatar(formData: FormData): Promise<Api.Result<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/my/avatar`, {
      method: 'POST',
      headers: await fetchHeaders(true),
      body: formData,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function deleteAvatar(): Promise<Api.Result<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/my/avatar`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
